export const PIXEL_RATIO = window.devicePixelRatio || 1;
export const VIEWPORT_RATIO = 0.98;
export const MAX_PJ_CONSIGNE = 10;
export const PJ_SIZE_LIMIT_MUTEX = 3200000;
